
import { BigNumber, Contract } from 'ethers';
import React, { useEffect, useState, useRef, Fragment } from 'react'
import styled, { css } from 'styled-components';
import { useAccount, useNetwork, useContractRead } from 'wagmi';
import { BootyABI } from '../../constants/ABI/BootyABI';
import { BOOTY_ADDRESS } from '../../constants/addresses';
import { CrateReveal } from './CrateReveal';
import { AddressZero } from '@ethersproject/constants'
import { crates, itemsMap } from './Items';
import { ConfirmActivate } from './ConfirmActivate';
import { useAppSelector } from '../../store/hooks';
import { POINTS_API } from '../../constants/urls';
import { breakpoints, Media } from '../../styles';
import { useWidthBreakpoint } from '../../hooks';
import { CONNECTED_CHAIN } from '@/constants/chains';
import { useEthersProvider, useEthersSigner } from '@/utils/wagmi-ethers-adapters/ethers';

interface InventoryProps {
    crateBalances: number[],
    artifactBalances: any[],
    updateBalances: () => void
}

export const Inventory = ({crateBalances, artifactBalances, updateBalances} : InventoryProps) => {
  const isTablet = useWidthBreakpoint(breakpoints.tablet)

  const rowLength = 3;  

  const { address : walletAddress, isConnected } = useAccount()

  const { data: signer } = useEthersSigner();
  const provider = useEthersProvider();
  
  const { chain: activeChain } = useNetwork();
  const validChain = activeChain?.name == CONNECTED_CHAIN
  
  const quotaTokens = ['shLP', 'Stablecoin', 'Ether', 'shWBTC']
  const [quotaAmounts, setQuotaAmounts] = useState<Record<string, number>>({})
  const [currentBoost, setCurrentBoost] = useState(1);
  const [activatedBoosters, setActivatedBoosters] = useState<{[booster: string] : number}>({})  

  const userQuotas = useAppSelector(state => state.quotas.quotas)
  const userBoosts = useAppSelector(state => state.points.boosts)[walletAddress!] ?? {}

  const [openAmounts, setOpenAmounts] = useState<Record<string, string>>({});
  const [openDisabled, setOpenDisabled] = useState(true);
  const [revealTxState, setRevealTxState] = useState('')
  const [revealVisible, setRevealVisible] = useState(false);

  const [confirmVisible, setConfirmVisible] = useState(false);
  const [mintedArtifacts, setMintedArtifacts] = useState<any[]>([]);

  const [activateAmounts, setActivateAmounts] = useState<Record<string, string>>({});
  const [activateDisabled, setActivateDisabled] = useState(true);

  const booty = new Contract(BOOTY_ADDRESS, BootyABI, signer || provider) // TODO: Migrate to BootyScreen?

  const artifactRows : any[] = []

  for(let i = 0; i < artifactBalances.length; i += rowLength)
    artifactRows.push(artifactBalances.slice(i, i + rowLength))

  const handleOpenCrateInput = (value: string, crateID: number, crateBalance: number) => {

    const newOpenAmounts = { ...openAmounts }
    value = value.replace(/\D/g, '');

    const key = crateID.toString()

    if (value) { // Value is not empty and is a positive integer
      if (parseInt(value) > crateBalance)
        newOpenAmounts[key] = crateBalance.toString()
      else if (value == '0')
        delete newOpenAmounts[key]
      else
        newOpenAmounts[key] = value;
    } else {
      delete newOpenAmounts[key]
    }
    setOpenAmounts(newOpenAmounts)

  }

  const handleActivateArtifactInput = (value: string, artifactID: string, artifactBalance: number) => {

    const newActivateAmounts = { ...activateAmounts }
    value = value.replace(/\D/g, '');

    if (value) { // Value is not empty and is a positive integer
      if (parseInt(value) > artifactBalance)
        newActivateAmounts[artifactID] = artifactBalance.toString()
      else if (value == '0')
        delete newActivateAmounts[artifactID]
      else
        newActivateAmounts[artifactID] = value;
    } else {
      delete newActivateAmounts[artifactID]
    }
    setActivateAmounts(newActivateAmounts)

  }

  const getTokenImage = (token: string) => {
    if (token == 'Stablecoin') {
      return (
        <>
          <img style={{ width: '14px', zIndex: '-1' }} src={`../../assets/coins/shUSDT.svg`} />
          <img style={{ position: 'absolute', width: '14px', marginLeft: '5px', height: '14px' }} src={`../../assets/coins/shDAI.svg`} />
          <img style={{ position: 'absolute', width: '14px', marginLeft: '10px' }} src={`../../assets/coins/shUSDC.svg`} />
        </>
      )
    } else if (token == 'Ether') {
      return (
        <>
            <img style={{ width: '14px', zIndex: '1' }} src={`../../assets/coins/shETH.svg`} />
            <img style={{ position: 'absolute', width: '14px', marginLeft: '-8px' }} src={`../../assets/coins/shwstETH.svg`} />
        </>
      )
    } else if (token == 'shWBTC') {
      return <img style={{ width: '14px', marginRight: '4px' }} src={`../../assets/coins/shWBTC.svg`} />
    } else if (token == 'shLP') {
      return <img style={{ width: '14px' }} src={`../../assets/coins/shLP.svg`} />
    } else {
      return <img style={{ width: '14px', margin: '0px 2px' }} src={`../../assets/coins/logo-placeholder.svg`} />
    }
  }

  const getArtifactDetails = (artifact: any) => {
    if (artifact.effect.type == "Booster") {
      return (
        <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: isTablet ? '4px' : '12px' }}>
          <Value style={{lineHeight: '12px', fontSize: '12px'}}>{`${artifact.effect.value == 0 ? '???' : artifact.effect.value + '%'}`}</Value>        
          <img style={{ width: isTablet ? '16px' : '24px', margin: '0 4px' }} src={`../../assets/icons/boost.svg`} />
          <Value style={{ lineHeight: '12px', fontSize: '12px' }}>{`${artifact.effect.duration}d`}</Value>
        </Row>
      )
    } else {

      const adjustedValue = artifact.effect.value >= 1000 ? `${artifact.effect.value / 1000}K` : artifact.effect.value
      return (
        <>
          <div style={{ display: 'flex', alignItems: 'center', margin: isTablet ? '4px 0' : '8px 0', justifyContent: 'center', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: '4px', width: '42.5%', justifyContent: 'right' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                {getTokenImage('shLP')}
                <Value style={{ textAlign: 'right', fontSize: '10px', lineHeight: '10px', marginLeft: '4px' }}>{`${adjustedValue}`}</Value>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                <div style={{ display: 'flex', marginRight: '14px' }}>
                  {getTokenImage('Stablecoin')}
                </div>
                <Value style={{ textAlign: 'right', fontSize: '10px', lineHeight: '10px' }}>{`${adjustedValue}`}</Value>
              </div>
            </div>
            <div style={{ width: '15%' }}></div>
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: '4px', width: '42.5%', justifyContent: 'left' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                <div style={{ display: 'flex', marginRight: '4px' }}>
                  {getTokenImage('Ether')}
                </div>
                <Value style={{ textAlign: 'right', fontSize: '10px', lineHeight: '10px' }}>{`${artifact.effect.value / 1000}`}</Value>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
                {getTokenImage('shWBTC')}
                <Value style={{ textAlign: 'right', fontSize: '10px', lineHeight: '10px' }}>{`${artifact.effect.value / 20000}`}</Value>
              </div>
            </div>
          </div>
        </>
      )
    }
  }

  const updateQuotaAmounts = async () => {

    const newQuotaAmounts = { ...quotaAmounts }

    for (let i = 0; i < quotaTokens.length; i++) {
        
      const tokenID = 
            quotaTokens[i] == 'Stablecoin' ? 'shDAI' : 
            quotaTokens[i] == 'shLP' ? 'DAI+USDC' : 
            quotaTokens[i] == 'Ether' ? 'shETH' : 
            quotaTokens[i]

      newQuotaAmounts[quotaTokens[i]] = parseFloat(
        userQuotas[tokenID] ??
        (await fetch(POINTS_API + walletAddress + '/quotas/' + tokenID).then(response => response.json()))
      )

    }
    return newQuotaAmounts
  }

  const updateBoost = async () => {

    const data = await fetch(POINTS_API + walletAddress + '/boost').then((response) => response.json())

    const newActivatedBoosters: any = {}
    Object.values(data.activatedArtifacts).forEach((artifact: any) => newActivatedBoosters[artifact.name] = userBoosts[artifact.name] ?? artifact.timeRemaining)

    return (
      {
        currentBoost: userBoosts['Active Boost'] ?? parseFloat(data.currentBoost),
        activatedBoosters: newActivatedBoosters
      }
    )

  }

  const openCrates = async () => {
    if (signer) {
      setOpenDisabled(true)
      setRevealVisible(true)

      const tiers = Object.keys(openAmounts)
      const amounts = Object.values(openAmounts).map((amount) => parseInt(amount))

      const gasEstimate = await booty.estimateGas.openCrate(tiers, amounts)

      booty.openCrate(tiers, amounts, { gasLimit: gasEstimate.mul(150).div(100) }).then((response: any) => {

        setRevealTxState('Submitted')

        response.wait().then((result: any) => {
          if (result.status == 1) { //Success
            const totalMints = [...Array(itemsMap.length)].map(x => 0);
            result.events.forEach((event: any) => {
              if (
                event.event == 'TransferSingle' &&
                event.args.length == 5 &&
                event.args[0] == walletAddress &&
                event.args[1] == AddressZero &&
                event.args[2] == walletAddress
              ) { // Event emitted by mintBatch
                let artifactID = BigNumber.from(event.args[3])
                let artifactAmount = BigNumber.from(event.args[4])
                totalMints[artifactID.toNumber()] += artifactAmount.toNumber()
              }
            })
            const newMintedArtifacts: any[] = []
            totalMints.forEach((mintAmount, index) => {
              if (mintAmount > 0) newMintedArtifacts.push({ image: itemsMap[index].image, amount: mintAmount })
            })
            setMintedArtifacts(newMintedArtifacts)
            setOpenAmounts({})
            setRevealTxState('Success')
            updateBalances();
          } else {
            setRevealTxState('Error')
            setOpenDisabled(false);
          }
        })
      }).catch(() => {
        setRevealTxState('')
        setOpenDisabled(false);
        setRevealVisible(false);
      });
    }
  }

  const closeReveal = () => {
    setRevealVisible(false)
    setMintedArtifacts([])
    setRevealTxState('')
  }

  useEffect(() => {
    setOpenDisabled(
      !isConnected ||
      !validChain ||
      Object.keys(openAmounts).length == 0
    )
    }, [openAmounts, isConnected, validChain])

  useEffect(() => {
    setActivateDisabled(
      !isConnected ||
      !validChain ||
      Object.keys(activateAmounts).length == 0
    )
    }, [activateAmounts, isConnected, validChain])

  useEffect(() => {
    setOpenAmounts({})
    setActivateAmounts({})

    let isMounted = true;

    updateBoost().then((boostData) => {
        if(isMounted){
            setCurrentBoost(boostData.currentBoost)
            setActivatedBoosters(boostData.activatedBoosters)
        }
    })

    updateQuotaAmounts().then((quotaData) => {
        if(isMounted)
            setQuotaAmounts(quotaData)
    })
    return () => { isMounted = false };
  }, [walletAddress])

  return (
    <>
      <InventoryHeader>
        <InventoryTitle>Crates</InventoryTitle>
      </InventoryHeader>
      <InventoryRow>
        <CratesRow>
          {crates.map((crate, index) => {
            const crateBalance = crateBalances[index] ?? 0
            const openAmount = parseInt(openAmounts[crate.crateID] ?? '0')
            return (
              <ItemContainer key={crate.name} selected={openAmount > 0}>
                <FlipContainer>
                  <Item none={crateBalance == 0}>
                    <img src={`../../assets/booty/${crate.image}.jpg`} style={{ width: '100%' }} />
                    <ItemBalance>{crateBalance.toString()}</ItemBalance>
                  </Item>
                  <Item style={{ transform: 'rotateY(180deg)', padding: '2px 4px', justifyContent: 'center' }}>
                    <ItemName>{crates[index].name}</ItemName>
                    <ItemDesc>{crates[index].desc}</ItemDesc>
                    <InputRow style={{ marginTop: '12px' }}>
                      <AddSubButton
                        style={{ marginRight: '8px' }}
                        disabled={openAmount == 0}
                        onClick={() => handleOpenCrateInput(openAmount > 1 ? (openAmount - 1).toString() : '', crate.crateID, crateBalance)}
                      >-</AddSubButton>
                      <Input
                        placeholder='0'
                        value={openAmounts[crate.crateID] ?? ''}
                        onChange={((e) => handleOpenCrateInput(e.target.value, crate.crateID, crateBalance))}
                        onFocus={(e) => e.target.placeholder = ''}
                        onBlur={(e) => e.target.placeholder = '0'}
                        disabled={(crateBalances[index] ?? 0) == 0}
                        inputMode={'numeric'}
                      />
                      <AddSubButton
                        style={{ marginLeft: '8px' }}
                        disabled={openAmount == crateBalance}
                        onClick={() => handleOpenCrateInput((openAmount + 1).toString(), crate.crateID, crateBalance)}
                      >+</AddSubButton>
                    </InputRow>
                    <Row>
                      <EdgeButton
                        disabled={openAmount == 0}
                        onClick={() => handleOpenCrateInput('0', crate.crateID, crateBalance)}
                      >Clear</EdgeButton>
                      <div style={{ width: '10px' }}></div>
                      <EdgeButton
                        disabled={openAmount == crateBalance}
                        onClick={() => handleOpenCrateInput(crateBalance.toString(), crate.crateID, crateBalance)}
                      >Max</EdgeButton>
                    </Row>
                  </Item>
                </FlipContainer>
              </ItemContainer>
            )
          })}
          {isTablet && (
            <CratesPanel
              openDisabled={openDisabled}
              openAmounts={openAmounts}
              openCrates={openCrates}
              revealVisible={revealVisible}
              closeReveal={closeReveal}
              revealTxState={revealTxState}
              mintedArtifacts={mintedArtifacts}
            />
          )}
        </CratesRow>
        {!isTablet && (
          <CratesPanel
            openDisabled={openDisabled}
            openAmounts={openAmounts}
            openCrates={openCrates}
            revealVisible={revealVisible}
            closeReveal={closeReveal}
            revealTxState={revealTxState}
            mintedArtifacts={mintedArtifacts}
          />
        )}
      </InventoryRow>
      <InventoryHeader>
        <InventoryTitle>Artifacts</InventoryTitle>
      </InventoryHeader>
      <InventoryRow>
        <CratesRow>
          {artifactRows.map((artifactRow, index) => {
            return (
              <Fragment key={index}>
                {artifactRow.map((pair: any) => {
                  const artifact = pair.artifact
                  const artifactBalance = pair.balance
                  const artifactID = itemsMap.findIndex((item : any) => item == artifact).toString() ?? '0'

                  const activateAmount = parseInt(activateAmounts[artifactID] ?? '0')

                  return (
                    <ItemContainer key={artifact.name} selected={activateAmount > 0}>
                      <FlipContainer>
                        <Item none={artifactBalance == 0}>
                          <img src={`../../assets/booty/${artifact.image}.jpg`} style={{ width: '100%' }} />
                          <ItemBalance>{artifactBalance.toString()}</ItemBalance>
                        </Item>
                        <Item style={{ transform: 'rotateY(180deg)', padding: '2px 4px', justifyContent: 'center' }}>
                          <ItemName textLength={artifact.name.length}>{artifact.name}</ItemName>
                          <ItemDesc>{artifact.desc}</ItemDesc>
                          {
                            artifact.effect && artifact.effect.type == 'Booster' &&
                            <>
                              {getArtifactDetails(artifact)}
                              <>
                                <InputRow>
                                    <AddSubButton
                                        style={{ marginRight: '8px' }}
                                        disabled={activateAmount == 0}
                                        onClick={() => handleActivateArtifactInput(activateAmount > 1 ? (activateAmount - 1).toString() : '', artifactID, artifactBalance)}
                                    >-</AddSubButton>
                                    <Input
                                        placeholder='0'
                                        value={activateAmounts[artifactID] ?? ''}
                                        onChange={((e) => handleActivateArtifactInput(e.target.value, artifactID, artifactBalance))}
                                        onFocus={(e) => e.target.placeholder = ''}
                                        onBlur={(e) => e.target.placeholder = '0'}
                                        disabled={artifactBalance == 0}
                                        inputMode={'numeric'}
                                    />
                                    <AddSubButton
                                        style={{ marginLeft: '8px' }}
                                        disabled={activateAmount == artifactBalance}
                                        onClick={() => handleActivateArtifactInput((activateAmount + 1).toString(), artifactID, artifactBalance)}
                                    >+</AddSubButton>
                                </InputRow>
                                <Row>
                                    <EdgeButton
                                        disabled={activateAmount == 0}
                                        onClick={() => handleActivateArtifactInput('0', artifactID, artifactBalance)}
                                    >Clear</EdgeButton>
                                    <div style={{ width: '10px' }}></div>
                                    <EdgeButton
                                        disabled={activateAmount == artifactBalance}
                                        onClick={() => handleActivateArtifactInput(artifactBalance.toString(), artifactID, artifactBalance)}
                                    >Max</EdgeButton>
                                </Row>
                            </>
                          </>
                        }
                        </Item>
                      </FlipContainer>
                    </ItemContainer>
                  )
                })}
              </Fragment>
            )
          })}
          {isTablet && (
            <ArtifactsPanel
              activateDisabled={activateDisabled}
              activateAmounts={activateAmounts}
              setActivateDisabled={setActivateDisabled}
              setConfirmVisible={setConfirmVisible}
              confirmVisible={confirmVisible}
              setActivateAmounts={setActivateAmounts}
              currentBoost={currentBoost}
              activatedBoosters={activatedBoosters}
              quotaAmounts={quotaAmounts}
              updateQuotaAmounts={updateQuotaAmounts}
              updateBoost={updateBoost}
              updateBalances={updateBalances}
            />
          )}
        </CratesRow>
        {!isTablet && (
          <ArtifactsPanel
            activateDisabled={activateDisabled}
            activateAmounts={activateAmounts}
            setActivateDisabled={setActivateDisabled}
            setConfirmVisible={setConfirmVisible}
            confirmVisible={confirmVisible}
            setActivateAmounts={setActivateAmounts}
            currentBoost={currentBoost}
            activatedBoosters={activatedBoosters}
            quotaAmounts={quotaAmounts}
            updateQuotaAmounts={updateQuotaAmounts}
            updateBoost={updateBoost}
            updateBalances={updateBalances}
          />
        )}
      </InventoryRow>
    </>
  )
}

interface CratesPanelProps {
  openDisabled: any
  openAmounts: any
  openCrates: any
  revealVisible: any
  closeReveal: any
  revealTxState: any
  mintedArtifacts: any
}

const CratesPanel = ({
  openDisabled,
  openAmounts,
  openCrates,
  revealVisible,
  closeReveal,
  revealTxState,
  mintedArtifacts
}: CratesPanelProps) => {
  const isTablet = useWidthBreakpoint(breakpoints.tablet)
  return (
    <ActionPreview pending={!openDisabled}>
      {Object.keys(openAmounts).length > 0 && (
        <ItemsPanel>
          {Object.keys(openAmounts).map((crateID: any) =>
            <ItemAmount key={crateID}>
              <img src={`../../assets/booty/${itemsMap[crateID].image}.jpg`}
                style={
                  isTablet
                    ? { width: '48px', borderRadius: '8px', border: 'solid 1px #464659' }
                    : { width: '56px', borderRadius: '8px', border: 'solid 1px #464659' }
                }
              />
              <Label style={{ color: 'white', marginTop: '6px' }}>{`x${openAmounts[crateID]}`}</Label>
            </ItemAmount>
          )}
        </ItemsPanel>
      )}
      <ExecuteButton onClick={openCrates} disabled={openDisabled}>Open Crates</ExecuteButton>
      <CrateReveal isVisible={revealVisible} onClose={closeReveal} revealTxState={revealTxState} mintedArtifacts={mintedArtifacts} />
    </ActionPreview>
  )
}

interface ArtifactsPanelProps {
  activateDisabled: any
  activateAmounts: any
  setActivateDisabled: any
  setConfirmVisible: any
  confirmVisible: any
  setActivateAmounts: any
  currentBoost: any
  activatedBoosters: any
  quotaAmounts: any
  updateQuotaAmounts: any
  updateBoost: any
  updateBalances: any
}

const ArtifactsPanel = ({
  activateDisabled,
  activateAmounts,
  setActivateDisabled,
  setConfirmVisible,
  confirmVisible,
  setActivateAmounts,
  currentBoost,
  activatedBoosters,
  quotaAmounts,
  updateQuotaAmounts,
  updateBoost,
  updateBalances,
}: ArtifactsPanelProps) => {
  const isTablet = useWidthBreakpoint(breakpoints.tablet)
  return (
    <ActionPreview pending={!activateDisabled}>
      {Object.keys(activateAmounts).length > 0 && (
        <ItemsPanel>
          {Object.keys(activateAmounts).map((artifactID : string) =>
            <ItemAmount key={artifactID}>
              <img src={`../../assets/booty/${itemsMap[parseInt(artifactID)].image}.jpg`}
                style={
                  isTablet
                    ? { width: '48px', borderRadius: '8px', border: 'solid 1px #464659' }
                    : { width: '56px', borderRadius: '8px', border: 'solid 1px #464659' }
                }
              />
              <Label style={{ color: 'white', marginTop: '6px' }}>{`x${activateAmounts[artifactID]}`}</Label>
            </ItemAmount>
          )}
        </ItemsPanel>
      )}
      <ExecuteButton
        disabled={activateDisabled}
        onClick={() => {
          setActivateDisabled(true)
          setConfirmVisible(true)
        }}
      >Activate Artifacts</ExecuteButton>
      <ConfirmActivate
        visible={confirmVisible}
        setVisible={setConfirmVisible}
        setActivateDisabled={setActivateDisabled}
        activateAmounts={activateAmounts}
        setActivateAmounts={setActivateAmounts}
        currentBoost={currentBoost}
        activatedBoosters={activatedBoosters}
        quotaAmounts={quotaAmounts}
        update={() => {
          updateQuotaAmounts()
          updateBoost()
          updateBalances()
        }}
      />
    </ActionPreview>
  )
}

const InventoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 16px;
  row-gap: 12px;
  width: 100%;
  max-width: 100%;
  flex-wrap: wrap;
  overflow: hidden;
  margin-bottom: 10px;
`

const InventoryTitle = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: #7D7D97;
  white-space: nowrap;
  letter-spacing: -0.02em;
`

const InventoryRow = styled.div`
  display: grid;
  grid-template-columns: auto minmax(170px, 1fr);
  column-gap: 24px;
  row-gap: 16px;
  width: 100%;
  max-width: 100%;

  & + ${InventoryHeader} {
    margin-top: 26px;
  }

  ${Media.tablet} {
    grid-template-columns: 1fr;
    column-gap: 8px;
    row-gap: 8px;
  }
`

const CratesRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 170px);
  column-gap: 16px;
  row-gap: 16px;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;

  ${Media.smallDesktop} {
    grid-template-columns: repeat(2, 170px);
  }

  ${Media.tablet} {
    grid-template-columns: repeat(auto-fill, 148px);
    column-gap: 8px;
    row-gap: 8px;
  }
`

const Label = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 17px;
  text-align: left;
  color: #7D7D97;
  white-space: nowrap;
  letter-spacing: -0.02em;
`;

const Value = styled(Label)`
  font-weight: 100;
  line-height: 24px;
  color: #00BDFF;
`

const Marketplaces = styled.div`
  display: flex;
  margin-right: 10px;
  column-gap: 8px;

  > a {
    filter: grayscale(100%);
  }

  > a:hover {
    filter: grayscale(0%);
  }
`

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const FlipContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;   
`

const ItemContainer = styled.div<{ selected?: boolean }>`
  background: transparent;
  width: 170px;
  height: 170px;
  perspective: 1000px;

  ${({ selected }) => !selected && css`
  &:hover ${FlipContainer} {
        transform: rotateY(180deg);
    }
  `};

  ${({ selected }) => selected && css`
    ${FlipContainer} {
      transform: rotateY(180deg);
    }

    ${Item} {
      border: solid 2px #00BDFF;
    }
  `};

  ${Media.tablet} {
    width: 148px;
    height: 148px;
  }
`;

const ItemsPanel = styled.div`
  display: flex;
  column-gap: 12px;
  row-gap: 8px;
  width: fit-content;
  max-width: 100%;
  flex-wrap: wrap;
  margin-bottom: 16px;
  margin-top: 16px;
  justify-content: center;
`

const Item = styled.div<{ none?: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  background: #151530;
  border: 2px solid #1E2239;
  border-radius: 16px;

  img {
    width: 100%;
    border-radius: 14px;
  } 

  ${({ none }) => none && css`
    filter: grayscale(100%);
  `};

  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
`

const ItemName = styled.p<{ textLength?: number }>`
  font-weight: 500;
  font-size: 16px;
  color: #00BDFF;
  margin-bottom: 4px;

  ${({ textLength }) => textLength && textLength > 18 && css`
    font-size: 13px;
  `};

  ${Media.tablet} {
    font-size: 12px;
    line-height: 14px;
  }

  ${Media.mobile} {
    font-size: 10px;
    line-height: 12px;
  }
`

const ItemDesc = styled.p`
  font-weight: 250;
  font-size: 11px;
  line-height: 13px;
  padding: 0 6px;

  ${Media.mobile} {
    font-size: 9px;
    line-height: 11px;
  }
`

const ItemBalance = styled.p`
  position: absolute;
  min-width: 40px;
  min-height: 40px;
  font-weight: 10;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  margin-top: 118px;
  margin-left: 118px;

  border-radius: 10px;
  background: #00BDFF;
  color: #1E2239;

  ${Media.tablet} {
    min-width: 36px;
    min-height: 36px;
    margin-top: 100px;
    margin-left: 100px;
  }
`

const InputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
`;

const inputTextStyles = css`
  font-size: 18px;
  line-height: 19px;

  ${Media.tablet} {
    font-size: 14px;
    line-height: 16px;
  }
`

const placeholderStyles = css`
  ${inputTextStyles}
`

export const Input = styled.input`
  width: 48px;
  padding-bottom: 4px;
  color: #FFFFFF;
  text-align: center;
  border: none;
  background: transparent;
  outline: none;
  font-weight: 1;

  ${inputTextStyles}

  &:focus {
    border-color: #FFFFFF;
  }

  &::-webkit-input-placeholder {
    ${placeholderStyles}
  }
  &::-moz-placeholder {
    ${placeholderStyles}
  }
  &:-ms-input-placeholder {
    ${placeholderStyles}
  }
  &:-moz-placeholder {
    ${placeholderStyles}
  }
`;

const AddSubButton = styled.button`
  border: none;
  border: solid 1px #00BDFF;
  border-radius: 6px;
  padding: 0;
  background: rgba(255, 255, 255,0);
  color: white;
  font-size: 12px;
  font-weight: 500;
  height: 24px;
  width: 24px;

  &:not(:disabled):hover {
    background: linear-gradient(90.44deg, #37dcf2 0.87%, #07c0fb 100%);
    color: #000E47;
  }

  &:disabled {
    border: solid 1px #464659;
    color: #464659;
    pointer-events: none;
  }

  ${Media.tablet} {
    border-radius: 24px;
  }
`

const EdgeButton = styled(AddSubButton)`
  height: 20px;
  width: 28px;
  font-size: 8px;
  font-weight: 1;
  ${Media.tablet} {
    height: 22px;
    width: 32px;
    font-size: 9px;
  }
`

const ActionPreview = styled.div<{ pending: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 170px;
  height: fit-content;
  min-height: 170px;
  padding: 6px 8px;
  background: #151530;
  border-radius: 16px;
  border: 1px solid #1E2239;

  ${({ pending }) => pending && css`
    border: solid 2px #00BDFF;
    box-shadow: 0 -2px 30px #00BDFF;
  `};

  ${Media.tablet} {
    min-width: 148px;
    min-height: 148px;
    grid-column: -1 / 1;
  }
`

const ItemAmount = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`

const ExecuteButton = styled.button`
  border: none;
  background: linear-gradient(90.44deg, #37dcf2 0.87%, #07c0fb 100%);
  color: #0a0e27;
  font-size: 16px;
  font-weight: 500;
  min-height: 48px;
  margin-top: auto;
  margin-bottom: 12px;
  width: 250px;
  max-width: 100%;
  padding: 4px 0px 4px 0px;
  border-radius: 16px;

  &:disabled {
    background: #0a0e27;
    color: #464659;
    border: solid 2px #464659;
  }
`